import { Dialog, Transition } from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/outline'
import brasilLocale from 'date-fns/locale/pt-BR'
import type React from 'react'
import { type FormEvent, Fragment, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from '../../components/button'
import { StepHeader } from '../../components/stepHeader'
import { documentFormatted } from '../../utils/documentFormatted'

import { ExclamationIcon } from '@heroicons/react/solid'
import { format } from 'date-fns'
import { showAlertError } from 'src/components/alertError'
import KeyboardPressPasswordEletronic from 'src/components/keyPressPasswordeletronic'
import { ModalLoader } from 'src/components/modalLoader'
import { OTPInput } from 'src/components/OTPInput'
import usePerformP2PTransaction from 'src/components/transferTax'
import {
  ModalContainer,
  ModalContent,
  ModalRoot,
} from 'src/components/ui/modal'
import { useNotification } from 'src/hooks/notification'
import { isAxiosError } from 'src/utils/isAxiosError'
import { useAuth } from '../../hooks/auth'
import { service, serviceError } from '../../services/ajio'
import InputInsertValue from './components/inputValue'
import {
  BoxContentWrapper,
  BoxInfoWrapper,
  ButtonsWrapper,
  Container,
  DataWrapper,
  Date as DateComponent,
  InfoWrapper,
  Key,
  // LabelInput,
  Name,
  // Value,
  WrapperHeader,
} from './styles'

interface StateProps {
  role: string
  number_identifier: string
  receiverId: string
  bank: {
    hidde?: string
    id?: number
    name?: string
  }
  type?: string
  beneficiaryType?: string
  id?: string | null
  name?: string
  virtualAccountId?: string
  document: string
  agency?: string
  account?: string
  digit?: string
}

interface PropsTed {
  id: string
}

export const TransferConfirmWallet: React.FC = () => {
  const navigate = useNavigate()
  const { account, refresh, user } = useAuth()
  // const { openTransferModal } = useModalTransfer();
  const location = useLocation()
  const [value, setValue] = useState(0)
  const [maskedValue, setMaskedValue] = useState('')
  const [error, setError] = useState('')

  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [tedData, setTedData] = useState<PropsTed>({} as PropsTed)

  const [pinOpen, setPinOpen] = useState(false)
  const [pin, setPin] = useState('')
  const [hasPin, setHasPin] = useState(false)
  const formRef = useRef<HTMLFormElement | null>(null)
  const [valueEletronic, setValueEletronic] = useState('')
  const [scheduled, setScheduled] = useState(false)
  const [scheduleDate, setScheduleDate] = useState<Date | null>('' as any)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { performP2PTransactions } = usePerformP2PTransaction()
  const [clickedValues, setClickedValues] = useState<string[]>([])

  const state = location.state as StateProps

  console.log('STATEEEEE', state)

  if (state === null) {
    navigate('/')
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleCancel = () => {
    navigate('/transfer-wallet/wallet-list')
  }

  const handleChange = (
    event: FormEvent,
    value: number,
    maskedValue: string
  ) => {
    event.preventDefault()

    setValue(value)
    setMaskedValue(maskedValue)
  }

  const handleConfirm = async (e: FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      console.log('Valor a ser enviado:', {
        amount: value,
        number_identifier_receiver: state?.number_identifier,
      })

      if (state?.bank) {
        const { data } = await service.post('/graphic/wallet-transfer', {
          amount: value,
          number_identifier_receiver: state?.number_identifier,
          virtual_account_sender: account.virtual_account_id,
          virtual_account_receiver: state?.virtualAccountId,
          receiver_id: state?.receiverId,
        })

        // Verifique a resposta recebida
        console.log('>>>>>>>>>>>>>>>>>>>>> Resposta da API:', data)

        setTedData(data.bank_transfer)
      } else {
        console.log('state state', state)
        setOpenNotification({
          type: 'success',
          title: 'Atualização Concluída:',
          notification: '',
        })
      }

      setLoading(false)
      setOpen(true)
      refresh()
    } catch (err) {
      setLoading(false)
      const error = serviceError(err)
      console.error('Erro na requisição:', err) // Adicione este log
      setError(error.friend)
      setHasPin(false)
    }
  }

  function onCloseModal() {
    setOpen(false)
    navigate('/extract')
  }

  const handleKeyPress = (prevValue: string) => {
    // ...
    setClickedValues((prevValue: any) => [...prevValue])
    // ...
  }

  const handlePasswordVerification = async (clickedValues: string[]) => {
    setIsSubmitting(true)
    try {
      await service.post(
        '/graphic/wallet-transfer',
        {
          amount: value,
          number_identifier_receiver: state.number_identifier,
          virtual_account_sender: account.virtual_account_id,
          virtual_account_receiver: state.virtualAccountId,
          receiver_id: state.receiverId,
        },
        {
          params: {
            security_key: clickedValues.join(''),
          },
        }
      )
      setOpen(true)
      setPinOpen(false)
    } catch (error) {
      if (isAxiosError(error) && error.response) {
        const errorMessage = (error.response.data as { error: string }).error
        showAlertError(errorMessage)
      } else {
        showAlertError('Ocorreu um erro inesperado.')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const updateValueEletronic = (newValue: any) => {
    setValueEletronic(newValue)
  }

  const handleUpdateClickedValues = (values: string[]) => {
    setClickedValues(values)
  }

  const { setOpenNotification } = useNotification()

  console.log('state---------/>', state, 'conta :', state.number_identifier)
  return (
    <Container className="w-full h-max-[50%] flex flex-col justify-center items-center">
      <form
        className="w-full max-w-[30%] h-full flex flex-col justify-center items-center"
        onSubmit={handleConfirm}
        ref={formRef}
      >
        <WrapperHeader className="self-start">
          <StepHeader
            handleGoBackFunction={handleGoBack}
            title="Confirme e transfira"
          />
        </WrapperHeader>
        <BoxInfoWrapper className="w-full h-full max-h-[67%] p-[32px] 4k:p-[6%]">
          <BoxContentWrapper>
            <InfoWrapper className="gap-1 4k:gap-8 5k:gap-12">
              <Name className="text-[8px] lg:text-base xl:text-base 2xl:text-base full-hd:text-xl 3xl-hd:text-xl qhd:text-2xl studio-laptop:text-3xl qhd-plus:text-4xl 4k:text-5xl 5k:text-6xl">
                {state?.name}
              </Name>

              <DataWrapper className="text-[8px] lg:text-sm xl:text-sm 2xl:text-sm full-hd:text-lg 3xl-hd:text-lg qhd:text-xl studio-laptop:text-2xl qhd-plus:text-3xl 4k:text-4xl 5k:text-5xl">
                <span>TIPO DE CONTA</span>
                <Key>{state?.role}</Key>
              </DataWrapper>
              <DataWrapper className="text-[8px] lg:text-sm xl:text-sm 2xl:text-sm full-hd:text-lg 3xl-hd:text-lg qhd:text-xl studio-laptop:text-2xl qhd-plus:text-3xl 4k:text-4xl 5k:text-5xl">
                <span>DOCUMENTO</span>
                <Key>{documentFormatted(state?.document || 'nulo aquii')}</Key>
              </DataWrapper>
              <DataWrapper className="text-[8px] lg:text-sm xl:text-sm 2xl:text-sm full-hd:text-lg 3xl-hd:text-lg qhd:text-xl studio-laptop:text-2xl qhd-plus:text-3xl 4k:text-4xl 5k:text-5xl">
                <span>BANCO</span>
                <Key>{state?.bank.name}</Key>
              </DataWrapper>
              <DataWrapper className="text-[8px] lg:text-sm xl:text-sm 2xl:text-sm full-hd:text-lg 3xl-hd:text-lg qhd:text-xl studio-laptop:text-2xl qhd-plus:text-3xl 4k:text-4xl 5k:text-5xl">
                <span>AGÊNCIA</span>
                <Key>{state?.agency}</Key>
              </DataWrapper>
              <DataWrapper className="text-[8px] lg:text-sm xl:text-sm 2xl:text-sm full-hd:text-lg 3xl-hd:text-lg qhd:text-xl studio-laptop:text-2xl qhd-plus:text-3xl 4k:text-4xl 5k:text-5xl">
                <span>CONTA</span>
                <Key>{state?.account}</Key>
              </DataWrapper>
            </InfoWrapper>
            <DateComponent className="text-[8px] lg:text-base xl:text-base 2xl:text-base full-hd:text-xl 3xl-hd:text-xl qhd:text-2xl studio-laptop:text-3xl qhd-plus:text-4xl 4k:text-5xl 5k:text-6xl">
              {format(new Date(), 'dd LLL yyyy HH:mm', {
                locale: brasilLocale,
              }).toUpperCase()}
            </DateComponent>
          </BoxContentWrapper>
          <InputInsertValue
            onChange={(event, value, masked) =>
              handleChange(event, value, masked)
            }
          />
          {/* <DateComponent>
            {format(new Date(), "dd LLL yyyy HH:mm", {
              locale: brasilLocale,
            }).toUpperCase()}
          </DateComponent> */}
          {/* {scheduled && (
						<div className="mt-4">
							<label
								htmlFor="scheduleDate"
								className="block text-sm font-medium text-yellow-500"
							>
								Data de agendamento:
							</label>
							<input
								type="date"
								id="scheduleDate"
								name="scheduleDate"
								value={
									scheduleDate ? scheduleDate.toISOString().split("T")[0] : ""
								}
								onChange={(e) => setScheduleDate(new Date(e.target.value))}
								className="mt-1 p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full"
							/>
						</div>
					)} */}
          {/* <button
            type="button"
            onClick={() => {
              setScheduled(!scheduled);
              if (scheduled == true) {
                setScheduleDate("" as any);
              }
            }}
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          >
            {scheduled ? "Cancelar Agendamento" : "Agendar Transferência"}
          </button> */}
        </BoxInfoWrapper>
        {/* <BoxWrapper></BoxWrapper> */}
        {!!error && (
          <div className="border-l-4 border-yellow-400 p-4 mt-5 w-[480px]">
            <div className="flex">
              <div className="flex-shrink-0">
                <ExclamationIcon
                  className="h-5 w-5 text-yellow-400"
                  aria-hidden="true"
                />
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700">{error}</p>
              </div>
            </div>
          </div>
        )}
        <ButtonsWrapper className="w-full">
          <Button
            handleFunction={handleCancel}
            color="#e3e3e3"
            title="Cancelar"
            height="h-[40px] xl:h-[44px] 4k:h-[120px]"
            fontSize="text-sm md:text-sm lg:text-sm xl:text-base 2xl:text-lg full-hd:text-2xl 3xl-hd:text-2xl qhd:text-3xl studio-laptop:text-4xl qhd-plus:text-4xl 4k:text-5xl 5k:text-5xl"
            rounded="rounded-[4px] xl:rounded-[4px] 4k:rounded-[12px]"
            backgroundColor="#FF1300"
          />
          {!hasPin ? (
            <Button
              type="button"
              isLoading={loading}
              title="Continuar"
              height="h-[40px] xl:h-[44px] 4k:h-[120px]"
              fontSize="text-sm md:text-sm lg:text-sm xl:text-base 2xl:text-lg full-hd:text-2xl 3xl-hd:text-2xl qhd:text-3xl studio-laptop:text-4xl qhd-plus:text-4xl 4k:text-5xl 5k:text-5xl"
              rounded="rounded-[4px] xl:rounded-[4px] 4k:rounded-[12px]"
              handleFunction={() => setPinOpen(true)}
            />
          ) : (
            <Button
              height="h-[40px] xl:h-[44px] 4k:h-[120px]"
              fontSize="text-sm md:text-sm lg:text-sm xl:text-base 2xl:text-lg full-hd:text-2xl 3xl-hd:text-2xl qhd:text-3xl studio-laptop:text-4xl qhd-plus:text-4xl 4k:text-5xl 5k:text-5xl"
              rounded="rounded-[4px] xl:rounded-[4px] 4k:rounded-[12px]"
              type="submit"
              isLoading={loading}
              title="Transferir"
            />
          )}

          <ModalRoot open={pinOpen} setIsOpen={setPinOpen}>
            <ModalContainer>
              <ModalContent>
                {isSubmitting ? (
                  <ModalLoader />
                ) : (
                  <div className="flex flex-col items-center">
                    <p className="text-[1.875rem] font-semibold text-center">
                      Insira a sua senha eletrônica de <br /> 8 dígitos para
                      confirmar a ação:
                    </p>
                    <OTPInput length={8} formData={clickedValues} />
                    <KeyboardPressPasswordEletronic
                      updateParentInput={updateValueEletronic}
                      updateClickedValues={setClickedValues}
                      onKeyPress={handleKeyPress}
                      onConfirm={handlePasswordVerification}
                    />
                  </div>
                )}
              </ModalContent>
            </ModalContainer>
          </ModalRoot>
          {/* <Transition.Root show={pinOpen} as={Fragment}>
						<Dialog as="div" className="relative z-10" onClose={setPinOpen}>
							<Transition.Child
								as={Fragment}
								enter="ease-out duration-300"
								enterFrom="opacity-0"
								enterTo="opacity-100"
								leave="ease-in duration-200"
								leaveFrom="opacity-100"
								leaveTo="opacity-0"
							>
								<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
							</Transition.Child>

							<div className="fixed z-10 inset-0 overflow-y-auto">
								<div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
									<Transition.Child
										as={Fragment}
										enter="ease-out duration-300"
										enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
										enterTo="opacity-100 translate-y-0 sm:scale-100"
										leave="ease-in duration-200"
										leaveFrom="opacity-100 translate-y-0 sm:scale-100"
										leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
									>
										<Dialog.Panel className="relative bg-darkgoldenrod rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-sm sm:w-full sm:p-6">
											<div>
												<div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
													<CheckIcon
														className="h-6 w-6 text-green-600"
														aria-hidden="true"
													/>
												</div>
												<div className="mt-3 text-center sm:mt-5">
													<Dialog.Title
														as="h3"
														className="text-lg leading-6 font-medium text-white"
													>
														Senha
													</Dialog.Title>
													<div className="mt-2">
														<p className="mt-5 flex justify-center">
															<div>
																<OTPInput length={8} formData={clickedValues} />
															</div>
														</p>
													</div>
												</div>
											</div>
											<div className="mt-5 sm:mt-6">
												<KeyboardPressPasswordEletronic
													updateParentInput={updateValueEletronic}
													updateClickedValues={setClickedValues}
													onKeyPress={handleKeyPress}
													onConfirm={handlePasswordVerification}
												/>

												<Button
													type="submit"
													isLoading={loading}
													title="Transferir"
													handleFunction={() => {
														const handlePasswordVerification = (
															clickedValues: string[],
														) => {
															// Verificar se clickedValues está vazio
															if (clickedValues.length === 0) {
																console.error(
																	"Erro: Nenhum valor fornecido. Digite a senha eletrônica.",
																);
																return;
															}

															const securityCode = account.security_eletronic;
															console.log("Sou securityCode", securityCode);
															console.log(
																"em handleFunction no pix confirm Sou clickedValues pra referencia fui resultado dos clicks do usuario no front end: ",
																clickedValues,
															);

															// Verifique cada posição de clickedValuesArray com os dígitos em securityCode
															let isPasswordCorrect = true;

															clickedValues.some((position, index) => {
																// Remove 'ou' e espaços e divide a posição em um array
																const digitsArray: string[] = position
																	.split(" ou ")
																	.map((digit) => digit.trim());

																console.log(
																	`Posição ${index + 1} - Original: ${position}, digitsArray:`,
																	digitsArray,
																);

																// Verifica se temos exatamente dois dígitos na posição (exceto na última posição)
																if (digitsArray.length !== 2) {
																	if (index === 7) {
																		// Se for a última posição, verifica se tem apenas um dígito
																		if (digitsArray.length !== 2) {
																			console.error(
																				`Erro: posição ${index + 1} não possui um dígito válido.`,
																			);
																			isPasswordCorrect = false;
																			return true; // Sai do loop
																		}
																	} else {
																		console.error(
																			`Erro: posição ${index + 1} não possui dois dígitos válidos.`,
																		);
																		isPasswordCorrect = false;
																		return true; // Sai do loop
																	}
																}

																// Continua com a lógica original de comparação
																const digitOptionsString = digitsArray.join("");
																const securityDigit = securityCode[index];
																console.log(
																	`Posição ${
																		index + 1
																	} - Comparando: digitOptions = ${digitOptionsString}, securityDigit = ${securityDigit}`,
																);

																// Ajuste na lógica de comparação
																const isDigitCorrect = digitsArray.some(
																	(digit) => digit === securityDigit,
																);
																console.log(
																	`Posição ${index + 1}: ${isDigitCorrect ? "Correta" : "Incorreta"}`,
																);

																if (!isDigitCorrect) {
																	isPasswordCorrect = false;
																	console.error(
																		"Senha incorreta! Algum dígito está errado.",
																	);
																	return true; // Sai do loop
																}

																return false; // Continua para a próxima posição
															});

															if (isPasswordCorrect) {
																// Senha correta, faça o que for necessário
																if (
																	scheduled &&
																	(!scheduleDate ||
																		isNaN(scheduleDate.getTime()))
																) {
																	setOpenNotification({
																		notification:
																			"Data de agendamento inválida",
																		title: "Data inválida",
																		type: "error",
																	});
																} else {
																	console.log("Senha correta!");
																	console.log("Sou boy 3");
																	setHasPin(true);
																	setPinOpen(false);
																	formRef.current?.requestSubmit();
																}
															} else {
																// Senha incorreta, faça o que for necessário
																console.error(
																	"Senha incorreta! Toda a senha está incorreta.",
																);
																console.log("Sou boy 23");
																setOpenNotification({
																	notification:
																		"Verifique sua senha e tente novamente",
																	title: "Senha incorreta",
																	type: "error",
																});
															}
														};

														handlePasswordVerification(clickedValues);
													}}
												/>
											</div>
										</Dialog.Panel>
									</Transition.Child>
								</div>
							</div>
						</Dialog>
					</Transition.Root> */}
        </ButtonsWrapper>
      </form>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={onCloseModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                  <div>
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                      <CheckIcon
                        className="h-6 w-6 text-green-600"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-5">
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Transferência realizada
                        <br />
                        {maskedValue}
                      </Dialog.Title>
                      <div className="mt-2 text-left">
                        <p className="text-sm text-gray-500">
                          <h2 className="mb-5 mt-5 text-lg">
                            Dados do favorecido
                          </h2>
                          <div>
                            <h2>Nome</h2>
                            <h3>{state?.name}</h3>
                          </div>

                          <div className="mt-5">
                            <h2>Documento</h2>
                            <h3>{documentFormatted(state?.document)}</h3>
                          </div>

                          <div className="mt-5 flex">
                            <div>
                              <h2>Agência</h2>
                              <h3>{state?.agency}</h3>
                            </div>

                            <div className="ml-28">
                              <h2>Conta</h2>
                              <h3>
                                {state?.account}-{state?.digit}
                              </h3>
                            </div>
                          </div>

                          <h2 className="mb-5 mt-5 text-lg">
                            Dados da conta debitada
                          </h2>

                          <div>
                            <h2>Nome</h2>
                            <h3>{user?.name}</h3>
                          </div>

                          <div className="mt-5">
                            <h2>Documento</h2>
                            <h3>{documentFormatted(user?.document)}</h3>
                          </div>

                          <div className="mt-5">
                            <h2>Banco</h2>
                            <h3>DELCRED SCD S.A.</h3>
                          </div>

                          {/* <div className="mt-5 flex">
													<div>
													  <h2>Agência</h2>
													  <h3>{account.branch}</h3>
													</div>
						
													<div className="ml-28">
													  <h2>Conta</h2>
													  <h3>
														{account?.accountNumber}-{account?.accountDigit}
													  </h3>
													</div>
												  </div> */}
                          {/* 
												  <div className="mt-5">
													<h2>ID da transação</h2>
													<h3>{tedData?.id}</h3>
												  </div> */}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-6">
                    <button
                      type="button"
                      className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
                      onClick={() => onCloseModal()}
                    >
                      Ir para o extrato
                    </button>

                    <button
                      type="button"
                      className="mt-5 inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2text-base font-medium  sm:text-sm text-black"
                      // onClick={() => onCloseModal()}
                    >
                      Comprovante disponível no extrato
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </Container>
  )
}
